module.exports = __webpack_public_path__ + "img/saturn.be5030ca.webp";